import {
  adjustmentSessionIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const MissingLocationInventorySchema_ = z.object({
  productId: productIdFormat.schema,
  productTitle: z.string(),
  locationName: z.string(),
});

export const MissingLocationInventorySchema: z.ZodType<MissingLocationInventory> =
  MissingLocationInventorySchema_;
export interface MissingLocationInventory
  extends z.infer<typeof MissingLocationInventorySchema_> {}

export const submitAdjustmentSession = {
  name: "submitAdjustmentSession" as const,
  input: z.object({
    sessionId: adjustmentSessionIdFormat.schema,
    /** If true, create location_inventory records for products that don't exist at the location */
    createMissingLocationInventory: z.boolean().optional(),
    notes: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    /** If true, the workflow is still processing and will complete shortly */
    pending: z.boolean().optional(),
    /** Products that don't have location_inventory at the session's location */
    missingLocationInventory: z
      .array(MissingLocationInventorySchema)
      .optional(),
  }),
};
